import { useRef, useState } from 'react'
import { formatNum } from '../../utils/functions'
import { NewFormSchema, QuestionSchema, SectionSchema } from '../../utils/types/form'

const newSection = {
  questions: [] as QuestionSchema[],
  meta: { showHeader: true }
} as SectionSchema

export const SectionWizard: React.FC<{
  form: NewFormSchema
  newSectionIndex: number
  section?: SectionSchema
  save: (section: SectionSchema, sectionIndex: number) => void
  reset: () => void
}> = (props) => {
  const { form, newSectionIndex, section: editSection, save, reset } = props

  const [section, setSection] = useState(editSection ?? newSection)
  const [sectionIndex, setSectionIndex] = useState(newSectionIndex)
  const [sectionSetting, setSectionSetting] = useState({ insert: false })
  const inputRef = useRef<HTMLInputElement>(null)
  const maxValue = useRef(form.sections.length + +`${editSection ? 0 : 1}`)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSection({ ...section, [e.target.id]: e.target.value })

  const handleSectionIndex = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSectionIndex(Number(e.target.value) - 1)

  const handleCheckboxChange = () => {
    !section.meta?.showHeader && inputRef.current?.focus()

    setSection({
      ...section,
      meta: { ...section.meta, showHeader: !section.meta?.showHeader }
    })
  }

  return (
    <section>
      <div className='section-new_item'>
        <h3>{`${editSection ? 'Edit' : 'New'}`} section</h3>
        <div className='section_question'>
          <span />
          <div className='section_new_questions'>
            <div />
            <div className='actions_container actions_container-alt'>
              <div className='actions-select actions-select-fg'>
                <span className='material-symbols-rounded material-symbols-sm'>segment</span>
                <div className='actions_series'>
                  <div onClick={() => setSectionSetting({ ...sectionSetting, insert: true })}>
                    <div className='div-with-icon div-with-icon-pd'>
                      <span>Section No:</span>
                      {sectionSetting.insert ? (
                        <input
                          type='number'
                          defaultValue={sectionIndex + 1}
                          onBlur={(e) => {
                            handleSectionIndex(e)
                            setSectionSetting({
                              ...sectionSetting,
                              insert: false
                            })
                          }}
                          min={1}
                          max={maxValue.current}
                          autoFocus
                          placeholder='--'
                        />
                      ) : (
                        <span className='span-input'>{formatNum(sectionIndex + 1)}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className='actions-options'>
                  <div className='checkbox_container checkbox_container-alt'>
                    <div>
                      <input
                        id='showHeader'
                        type='checkbox'
                        defaultChecked={section.meta?.showHeader}
                        onChange={handleCheckboxChange}
                        hidden
                      />
                      <span
                        className={`material-symbols-rounded ${section.meta?.showHeader ? 'on' : ''}`}
                        onClick={handleCheckboxChange}>
                        {section.meta?.showHeader ? 'toggle_on' : 'toggle_off'}
                      </span>
                      <label htmlFor='showHeader'>Show header</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <label htmlFor='name'>
              Title:<em className='required'>*</em>
            </label>
            <input
              id='name'
              defaultValue={section.name}
              onChange={handleChange}
              autoFocus
              placeholder='Enter section title...'
              readOnly={!section.meta?.showHeader}
              ref={inputRef}
            />
            <label htmlFor='description'>Description:</label>
            <input
              id='description'
              defaultValue={section?.description}
              onChange={handleChange}
              placeholder='Description (optional)...'
              readOnly={!section.meta?.showHeader}
            />
            <div />
            <div className='form_actions'>
              <div className='div-with-icon' onClick={reset}>
                <span className='material-symbols-rounded'>close</span>
                <span>Cancel</span>
              </div>
              <button
                className='button-with-icon'
                onClick={() => save(section, sectionIndex)}
                disabled={
                  (!section.name && section.meta?.showHeader) ||
                  !(sectionIndex >= 0 && sectionIndex < maxValue.current)
                }>
                <span className='material-symbols-rounded'>check</span>
                <span>Confirm</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
